import styled from 'styled-components'

export default styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 36px;
`
